import { render, staticRenderFns } from "./CommonPop.vue?vue&type=template&id=5405c41c&scoped=true"
import script from "./CommonPop.vue?vue&type=script&lang=js"
export * from "./CommonPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5405c41c",
  null
  
)

export default component.exports